import { setCampaignContributionPagination } from 'modules/iterableGoals/ducks/actions';
import {
  CampaignContributionsInfoData,
  CampaignContributionsResultsData,
  PaginationInput,
  SortInput,
} from 'modules/iterableGoals/types';
import { useDispatch } from 'react-redux';
import { PAGE_SIZES } from 'ui/paginationFooter';
import { Table } from 'ui/table';
import { Body } from './Body';
import { Header } from './Header';
import { StyledPaginationFooter, TableWrapper } from './Styled';

type CampaignContributionTablePropType = {
  sort: SortInput;
  pagination: PaginationInput;
  results: CampaignContributionsResultsData[];
  info?: CampaignContributionsInfoData;
};

export const CampaignContributionTable = ({
  sort,
  pagination,
  results,
  info,
}: CampaignContributionTablePropType) => {
  const dispatch = useDispatch();

  return (
    <TableWrapper>
      <Table>
        <Header sort={sort} />
        <Body results={results} />
      </Table>
      <StyledPaginationFooter
        onUpdate={(e) =>
          dispatch(
            setCampaignContributionPagination({
              page: e.page,
              offset: (e.page - 1) * e.pageSize,
              limit: e.pageSize,
            }),
          )
        }
        pageSizes={PAGE_SIZES}
        currentPage={pagination.page}
        itemsPerPage={pagination.limit}
        numItems={info?.count}
      />
    </TableWrapper>
  );
};
